import React from 'react';
import { CtaButton } from '../CtaButton';
import { AUTHOR_URL } from '../../data/content';
export function Author() {
  return <section className="w-full bg-panel py-16 sm:py-24" data-id="element-85" data-mp="1htc4t41f79f5">
      <div className="mx-auto grid max-w-5xl items-center gap-8 px-4 md:grid-cols-[0.8fr_1fr] md:gap-12" data-id="element-86" data-mp="1wh6xwljcbfsr">
        <img src={AUTHOR_URL} alt="Jason Mitchell in his workshop" className="mx-auto w-full max-w-sm rounded-3xl border-4 border-brand object-cover md:max-w-none" data-id="element-87" data-mp="1rpf84d80de3o" />
        <div data-id="element-88" data-mp="20j1y1mpjbn4y">
          <p className="font-display text-lg font-bold uppercase tracking-wider text-alert" data-id="element-89" data-mp="20h8skaqnr8yj">Meet the author</p>
          <h2 className="font-display text-5xl font-black uppercase leading-none text-white sm:text-6xl" data-id="element-90" data-mp="2ff12mndfr55c">Jason Mitchell</h2>
          <p className="mt-2 font-display text-xl font-bold text-brand" data-id="element-91" data-mp="2aedbm1p7iob4">Automotive Diagnostics — Practical Blueprint Collection</p>
          <div className="mt-5 space-y-3 text-lg leading-relaxed text-body" data-id="element-92" data-mp="g2oym52jcvtd">
            <p data-id="element-93" data-mp="g4rw1a60pr84">
              Author of <strong className="text-white" data-id="element-94" data-mp="3gew753amd3i9">Automotive No-Start Diagnostic Blueprint™</strong>. Also associated with the
              OBD2 Diagnostic Blueprint™ collection.
            </p>
            <p data-id="element-95" data-mp="3pfatm5zbkonc">
              The Automotive No-Start Diagnostic Blueprint™ follows the same practical editorial direction: organized workflows,
              diagnostic decision tools, and structured documentation for automotive troubleshooting.
            </p>
            <p className="font-semibold text-white" data-id="element-96" data-mp="2z6j4f8dtigw">
              The focus is straightforward: give working technicians a clear process they can apply during actual diagnostic
              investigations.
            </p>
            <p data-id="element-97" data-mp="gz8zfx11k3u1">
              Rather than relying on lengthy theoretical explanations, the collection emphasizes actionable tools designed around
              common workshop responsibilities.
            </p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-5xl px-4" data-id="element-98" data-mp="2irdq756t0v36">
        <CtaButton className="mt-12" label="Learn Jason’s Diagnostic Pathway" data-id="element-99" data-mp="3m1i3arrq5fse" />
      </div>
    </section>;
}